module.exports = __webpack_public_path__ + "img/115.bab3317d.jpg";